import { render } from "./RegisterPointOfInterest.vue?vue&type=template&id=ebecc1dc"
import script from "./RegisterPointOfInterest.vue?vue&type=script&lang=js"
export * from "./RegisterPointOfInterest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__